/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GermanLegacyEssayProjector } from './germanLegacyEssayProjector';
import type { GermanLegacyOralProjector } from './germanLegacyOralProjector';
import type { BinaryPassFailProjector } from './binaryPassFailProjector';
import type { GermanBandedProjector } from './germanBandedProjector';

export type TenantPublicGradingSettingsGradeProjectorAnyOf =
  | GermanLegacyEssayProjector
  | GermanLegacyOralProjector
  | BinaryPassFailProjector
  | GermanBandedProjector;
